import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { SkipFinanceService } from '@app/configure/services/skip-finance.service';
import { ConfigureService } from '@app/configure/services/configure.service';
import { SessionService } from '@app/core/services/session.service';
import { ModalService } from '@app/core/services/modal.service';

import { FinanceParams } from '@app/configure/models/finance-params.model';

@Component({
	selector: 'cng-configure-purchase-vehicle',
	templateUrl: './purchase-vehicle.component.html',
	styleUrls: ['./purchase-vehicle.component.less'],
})
export class ConfigurePurchaseVehicleComponent implements OnInit, OnDestroy {
	//  COMPONENT VARIABLES

	mode: 'vehicle' | 'enquiry';
	vehicle_id: number;
	enquiry_hash: string;
	key: string = '';
	current_step_key: string = 'purchase_vehicle';
	customer: any = this.configure_service.configure_data.meta.customer;
	vehicle: any = this.configure_service.configure_data.steps.purchase_vehicle.data;
	website_url: string = this.session_service.getDealer().website_url || null;
	step_mode: string = this.configure_service.getStepMode();
	reserve_enabled: boolean = this.configure_service.isStepEnabled('payment');
	get_started_text: string = 'Get Started';

	destroyed$: Subject<boolean> = new Subject<boolean>();

	/**
	 * Constructs class and injects dependencies.
	 *
	 * @param {ConfigureService} configure_service
	 * @param {SessionService} session_service
	 * @param {ActivatedRoute} activated_route
	 * @param {ModalService} modal_service
	 */
	constructor(
		public configure_service: ConfigureService,
		private session_service: SessionService,
		private activated_route: ActivatedRoute,
		private modal_service: ModalService,
		private skip_finance_service: SkipFinanceService
	) {}

	/**
	 * Lifecycle hook: Subscribes to router events and deal changes.
	 */
	ngOnInit(): void {
		this.overrideMonthlyPayment();

		this.activated_route.parent.params.pipe(takeUntil(this.destroyed$)).subscribe((params) => {
			if (params['vehicle_id']) {
				this.mode = 'vehicle';
				this.vehicle_id = params['vehicle_id'];
			} else {
				this.mode = 'enquiry';
				this.enquiry_hash = params['enquiry_hash'];
			}
		});

		this.configure_service.configure_data$.pipe(takeUntil(this.destroyed$)).subscribe((configure_data) => {
			this.customer = configure_data.meta.customer;
			this.vehicle = configure_data.steps.purchase_vehicle.data;

			this.overrideMonthlyPayment();
		});

		if (this.mode === 'enquiry') {
			this.configure_service.track('step.moved', { step: this.current_step_key }).subscribe();
		}

		this.configure_service.trackJourney().subscribe();

		switch (this.step_mode) {
			case 'part_exchange':
				this.get_started_text = 'Get My Valuation';
				break;
			case 'reserve':
				this.get_started_text = 'Reserve This Vehicle';
				break;
		}
	}

	overrideMonthlyPayment(): void {
		const finance_params: FinanceParams = this.session_service.getFinanceParams();

		if (finance_params && finance_params.monthly_payment) {
			this.vehicle.regular_payment = finance_params.monthly_payment;
		}
	}

	/**
	 * Shows customer details modal via modal service.
	 */
	onShowCustomerDetails(): void {
		this.modal_service.show(['configure/customer-details', 'vehicle', this.vehicle_id.toString()]);
	}

	/**
	 * Jumps to step.
	 *
	 * @param {string} new_step_key
	 */
	jumpTo(new_step_key: string): void {
		// this.skip_finance_service.onJumpSteps(new_step_key, (canProceed: boolean) => {
		// 	if (canProceed) {
		this.saveAndGoTo(new_step_key);
		// 	}
		// });
	}

	/**
	 * Navigates to step via configure service.
	 *
	 * @param {string} new_step_key
	 */
	saveAndGoTo(new_step_key: string): void {
		this.configure_service.navigateToStep(new_step_key);
	}

	/**
	 * Destroys component and any open subscriptions.
	 */
	ngOnDestroy(): void {
		this.destroyed$.next(true);
	}
}
